import { Component, input, output, model } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface TabItem {
  id: string;
  label: string;
  icon?: string;
}

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="tabs-card">
      <nav class="tabs-bar" role="tablist">
        @for (tab of tabs(); track tab.id) {
          <button
            type="button"
            class="tabs-bar__tab"
            [class.tabs-bar__tab--active]="activeTab() === tab.id"
            (click)="activeTab.set(tab.id)"
            role="tab"
            [attr.aria-selected]="activeTab() === tab.id"
          >
            @if (tab.icon) { <i class="bi {{ tab.icon }}"></i> }
            {{ tab.label }}
          </button>
        }
      </nav>
      <ng-content />
    </div>
  `,
  styles: [`
    .tabs-card {
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 1px 6px rgba(0, 0, 0, .06);
      overflow: hidden;
    }

    .tabs-bar {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
      gap: 0;
      border-bottom: 1px solid #f1f5f9;
      padding: 0 8px;
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
      }
    }

    .tabs-bar__tab {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 14px 20px;
      background: transparent;
      border: none;
      border-bottom: 2px solid transparent;
      font-size: 14px;
      font-weight: 500;
      color: #64748b;
      cursor: pointer;
      transition: color 0.15s, border-color 0.15s;
      flex-shrink: 0;
      white-space: nowrap;
      i { font-size: 15px; }

      &:hover { color: #1e293b; }

      &--active {
        color: var(--color-primary, #2C5F5D);
        border-bottom-color: var(--color-primary, #2C5F5D);
        font-weight: 600;
      }
    }
  `],
})
export class TabsComponent {
  readonly tabs = input.required<TabItem[]>();
  readonly activeTab = model.required<string>();
}
